import React from 'react';
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../../services/Authorization";
import {FormattedMessage, injectIntl} from "react-intl";
import moment from 'moment';
import Constants from "../../../services/Constants";
import SADatePicker from "../../common/input/SADatePicker";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import {Table} from "antd";
import RentalReportingModal from "./RentalReportingModal";
import BoldText from "../../common/text/BoldText";
import './CarDeliveryPlanning.css';

const Column = Table.Column;

class CarDeliveryPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      date: moment().format(Constants.DATE_FORMAT_API),
      selectedRental: undefined,
    }
  }

  componentDidMount() {
    const {date} = this.state;
    this.props.dispatchFetchRentalDeliveryPlanning({date})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.intervention) {
      this.setState({...nextProps.intervention})
    }
    if (nextProps.deliveryPlanning && nextProps.deliveryPlanning.planning) {
      this.setState({planning: nextProps.deliveryPlanning.planning})
    }
    if (nextProps.fetchRentalContract && nextProps.fetchRentalContract.contract) {
      this.setState({contract: nextProps.fetchRentalContract.contract});
    }
  }

  onDateUpdate = date => {
    const formattedDate = date && moment(date).format(Constants.DATE_FORMAT_API);
    this.setState({date: formattedDate});
    this.props.dispatchFetchRentalDeliveryPlanning({date: formattedDate});
  };

  onPrint = () => {
    window.print();
  };

  onModalClose = () => {
    this.props.hideModal();
  };

  onSelect = (rentalDetails, rentalVehicle) => {
    if (rentalDetails.rentingJourney) {
      const {rentingJourney: {journeyUuid, customer}} = rentalDetails;

      this.props.dispatchFetchRentalReporting(rentalDetails.id);
      this.props.dispatchFetchJourneyIdentityDocuments({uuid: journeyUuid, connectedUserId: customer.id});
      this.props.dispatchFetchRentalContract(rentalDetails.id);

      this.setState({rentalVehicle, rentalDetails});
      this.props.showModal();
    }
  };

  onFilterChange = (values, confirm) => {
    const {deliveryPlanning: {planning = []} = {}} = this.props;
    this.setState({planning});
    confirm();
  };

  render() {
    const {intl: {formatMessage}, deliveryPlanning: {loading}, fetchRentalReporting: {reporting, showModal}} = this.props;
    const {date, rentalVehicle, rentalDetails, identityDocuments, contract, planning = []} = this.state;
    const journeyUuid = rentalDetails && rentalDetails.journeyUuid;

    return (
      <section className="delivery-planning box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            <FormattedMessage id="section.car-delivery.title"/>
          </h2>
          <div className="box-heading__right">
            <button onClick={this.onPrint} type="primary" className="btn btn-sm btn-primary right print-btn">
              <FormattedMessage id="action.print"/>
            </button>
          </div>
        </header>

        <div className="box__body">
          <div className="table-wrapper__header">
            <SADatePicker value={date} onChange={this.onDateUpdate}/>
          </div>
          {
            loading ? (
              <LoadingIndicator/>
            ) : (
              <div className="table-wrapper__body">
                <Table className="table overview-table" dataSource={planning} pagination={false}
                       onRowClick={rental => this.onSelect(rental.rentalDetails, rental.rentalVehicle)}>
                  <Column key="filterType"
                          title={formatMessage({id: 'type'})}
                          dataIndex="status"
                          render={status => (<FormattedMessage id={`vehicle.report.${status.toLowerCase()}`}/>)}
                  />
                  <Column key="rent-type"
                          dataIndex="rentalDetails"
                          title={formatMessage({id: 'customer.origin'})}
                          render={rentalDetails => (
                            <FormattedMessage id={`customer.${rentalDetails.rentingCustomer ? 'external' : 'internal'}`}/>
                          )}
                  />
                  <Column key="category"
                          dataIndex="rentalVehicle.category"
                          title={formatMessage({id: 'vehicle.category'})}
                          render={category => (<FormattedMessage id={`mobility.${category}`}/>)}
                  />
                  <Column key="modelBrand"
                          dataIndex="rentalVehicle"
                          title={formatMessage({id: 'vehicle.make'}) + ' & ' + formatMessage({id: 'vehicle.model'})}
                          render={rentalVehicle => (
                            <div>
                              <span>{rentalVehicle.brand}</span>
                              <br/>
                              <span>{rentalVehicle.model}</span>
                            </div>
                          )}
                  />
                  <Column key="vehiclePlate"
                          dataIndex="rentalVehicle"
                          title={formatMessage({id: 'vehicle.vin'}) + ' & ' + formatMessage({id: 'vehicle.plate'})}
                          render={rentalVehicle => (
                            <div>
                              <BoldText text={rentalVehicle.vin} boldEndCharacters={7}/>
                              <br/>
                              <span>{rentalVehicle.licensePlate}</span>
                            </div>
                          )}
                  />
                  <Column key="customer"
                          dataIndex="rentalDetails"
                          title={formatMessage({id: 'summary.customer'})}
                          render={rentalDetails => {
                            const customer = (rentalDetails.rentingJourney && rentalDetails.rentingJourney.customer) || rentalDetails.rentingCustomer || {};
                            return (
                              <div>
                                <span>{customer.firstName} {customer.lastName}</span>
                                <br/>
                                <span>{customer.phone}</span>
                              </div>
                            )
                          }}
                  />
                </Table>
                <RentalReportingModal visible={showModal} onModalClose={this.onModalClose} rentalVehicle={rentalVehicle}
                                      reporting={reporting} rentalDetails={rentalDetails} identityDocuments={identityDocuments}
                                      journeyUuid={journeyUuid} contract={contract}
                />
              </div>
            )
          }
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention || {},
  deliveryPlanning: state.fetchRentalDeliveryPlanning,
  fetchRentalReporting: state.fetchRentalReporting,
  fetchRentalContract: state.fetchRentalContract
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchRentalDeliveryPlanning: params => dispatch({type: 'FETCH_RENTAL_DELIVERY_PLANNING.REQUEST', params}),
  showModal: () => dispatch({type: 'SHOW_DELIVERY_MODAL'}),
  hideModal: () => dispatch({type: 'HIDE_DELIVERY_MODAL'}),

  dispatchFetchJourneyIdentityDocuments: (params) => dispatch({type: 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', ...params}),
  dispatchFetchRentalReporting: rentalDetailsId => dispatch({type: 'FETCH_RENTAL_REPORTING.REQUEST', rentalDetailsId}),
  dispatchFetchRentalContract: rentalDetailsId => dispatch({type: 'FETCH_RENTAL_CONTRACT.REQUEST', rentalDetailsId}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(CarDeliveryPlanning), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
